/** Public-facing labels for broker source trust (no internal metrics). */

export function getPublicSourceTrustLabel(source = {}) {
  const trustLabel = source.trust_label || source.trustLabel;
  const trustScore = source.trust_score ?? source.trustScore;
  const confidence = source.trust_confidence || source.trustConfidence;

  if (trustLabel && !trustScore && !confidence) {
    return { label: trustLabel, tone: source.trust_tone || source.trustTone || "neutral" };
  }

  if (trustScore == null || confidence === "UNKNOWN" || confidence === "LOW") {
    return { label: "New source", tone: "neutral" };
  }

  if (trustLabel === "Excellent" || trustLabel === "Good") {
    return { label: "Good source", tone: "success" };
  }

  if (trustLabel === "Fair") {
    return { label: "Trusted source", tone: "medium" };
  }

  return { label: "Needs verification", tone: "warning" };
}

export function getAggregateSourceTrustLabel(properties = []) {
  const activeCount = properties.reduce(
    (sum, property) => sum + (property.activeSourceCount || 0),
    0
  );

  if (activeCount > 1) {
    return { label: "Multiple trusted sources", tone: "success" };
  }

  return null;
}

export function trustScoreTone(score) {
  if (score == null) {
    return "neutral";
  }

  if (score >= 75) {
    return "success";
  }

  if (score >= 60) {
    return "medium";
  }

  if (score >= 40) {
    return "warning";
  }

  return "danger";
}
